"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.ButtonWrapper = exports.BannerStyled = exports.BannerCloseButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = require("../style/colors");
var _fonts = require("../style/fonts");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BannerStyled = exports.BannerStyled = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "style__BannerStyled",
  componentId: "bufferapp-ui__sc-hfz1b9-0"
})(["align-items:center;background:", ";box-sizing:border-box;color:", ";display:flex;font-family:", ";font-size:", ";height:48px;padding-left:8px;padding-right:32px;position:relative;width:100vw;a{color:", ";}"], props => props.themeColor === 'blue' ? _colors.blueDarker : _colors.orangeLighter, props => props.themeColor === 'blue' ? _colors.white : _colors.orangeDarker, _fonts.fontFamily, _fonts.fontSize, props => props.themeColor === 'blue' ? _colors.white : _colors.orangeDarker);
const BannerCloseButton = exports.BannerCloseButton = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "style__BannerCloseButton",
  componentId: "bufferapp-ui__sc-hfz1b9-1"
})(["position:absolute;right:8px;"]);
const Wrapper = exports.Wrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "bufferapp-ui__sc-hfz1b9-2"
})(["display:flex;justify-content:center;align-items:center;flex:1 1 auto;"]);
const ButtonWrapper = exports.ButtonWrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "style__ButtonWrapper",
  componentId: "bufferapp-ui__sc-hfz1b9-3"
})(["margin-left:16px;"]);